import BlockRenderer from "./BlockRenderer";
import { useSiteContent } from "./useSiteContent";

/** Builds the public page component for a built-in, fully block-driven
 * page — the same shape as AboutUs.jsx/ContactUs.jsx. */
export default function createCmsPage(pageKey) {
  return function CmsPage() {
    const { blocks } = useSiteContent(pageKey);
    return (
      <div className="min-h-screen bg-[#0B2421]">
        <BlockRenderer blocks={blocks} />
      </div>
    );
  };
}
